module.exports = __webpack_public_path__ + "static/media/bronzeMedal.d38871b9.png";